import React from 'react';
import QRReaderForm from './QRReaderForm';
export default function AddQRReader() {
  return <QRReaderForm />;
}
